import { Employee } from './employee.model';

export class SystemSettings {
  constructor(
    public id?: number,
    public formalApproverSectionDescription?: string,
    public systemFormalApprovers?: Employee[],
  ) {}

  static adapt(item: any): SystemSettings {
    return new SystemSettings(
      item.id,
      item.formalApproverSectionDescription,
      item.systemFormalApprovers || []
    );
  }
}
